export default function firstLine(text) {
  const idx = text.indexOf('\n');
  if (idx < 0) {
    return text;
  }

  return text.slice(0, idx).trim();
}
